export enum RoleNameEnum{
    ADMIN = 'Admin',
    PLAYER = 'Player',
    TEAM_MANAGER = 'Team Manager',
    TEAM_COACH = 'Team Coach',
    TOURNAMENT_MANAGER = 'Tournament Manager',
}